﻿import {RefObject} from "react";

export function getHtmlElement(mainRef: RefObject<HTMLElement | null> | HTMLElement | string): HTMLElement | null {
	if (typeof mainRef === "string") {
		return document.getElementById(mainRef);
	}

	return mainRef == null ? null : mainRef instanceof HTMLElement ? mainRef : mainRef.current;
}
